export function adaptDetectionSummaryBlock(
  entry: Record<string, unknown>,
  _baseUrl: string,
): Record<string, unknown> {
  const items = (entry['items'] as Array<{ label: string; value: string; href?: string; highlight?: boolean }>) ?? [];
  return { items };
}
